import React from 'react'
import styles from './GoalTypeCards.scss'
import { Link } from 'react-router-dom'
import { Icon } from 'common/Icon'
import { FormattedMessage as T } from 'react-intl'

export class GoalTypeCards extends React.PureComponent {
  render () {
    return (
      <div className={styles.GoalTypeCards}>
        <GoalType
          type='distance'
          icon='goals-ride-icon'
          title={<T id='GoalTypeCards.rideFarther' defaultMessage='Ride Farther' />}
          description={<T id='GoalTypeCards.rideFarther.goalDescription' defaultMessage='Challenge yourself to ride a certain distance' />} />
        <GoalType
          type='moving_time'
          icon='goals-time-icon'
          title={<T id='GoalTypeCards.moreBikeTime' defaultMessage='More Bike Time' />}
          description={<T id='GoalTypeCards.moreBikeTime.goalDescription' defaultMessage='Set a goal to up your time spent riding' />} />
        <GoalType
          type='elevation_gain'
          icon='goals-climb-icon'
          title={<T id='GoalTypeCards.climbHigher' defaultMessage='Climb Higher' />}
          description={<T id='GoalTypeCards.climbHigher.goalDescription' defaultMessage='See how much elevation gain you can do' />} />
        <GoalType
          type='leaderboard'
          icon='goals-challenge-icon'
          title={<T id='GoalTypeCards.challenge' defaultMessage='Challenge Friends' />}
          description={<T id='GoalTypeCards.challenge.goalDescription' defaultMessage='See who can do the most mileage or climbing before the challenge ends' />} />
      </div>
    )
  }
}

const GoalType = ({ type, icon, title, description }) => (
  <Link to={`/goals/new?type=${type}`} className={styles.GoalType}>
    <Icon i={icon} size={60} className={styles.icon} />
    <h3 className={styles.title}>{title}</h3>
    <p>{description}</p>
  </Link>
)
